import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { resetAll } from "./actions/resetAll";


const initialState: {[identificadorItem: number] : IItemOrcamento} = {}

const atualizacaoItensOrcamentoLegadoSlice = createSlice({
    name: "atualizacaoItensOrcamentoLegado",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        atualizarItem: (atualizacaoItensOrcamentoLegado, action: PayloadAction<{identificador: number, dadosItem: IItemOrcamento}>) => {
            console.warn('atualizacaoItensOrcamentoLegado reducer atualizarItem chamado. atualizacao tardia do estado legado foi descontinuada. este reducer nao sera executado')
            return initialState
            /* codigo abaixo nunca seria executado
            atualizacaoItensOrcamentoLegado[action.payload.identificador] = action.payload.dadosItem
            */
        },
        limpar: () => {
            console.warn('atualizacaoItensOrcamentoLegado reducer limpar chamado. atualizacao tardia do estado legado foi descontinuada')
            
            return initialState
        }
    }
})

export default atualizacaoItensOrcamentoLegadoSlice.reducer

export const {
    atualizarItem, limpar
} : {
    atualizarItem: ActionType<{identificador: number, dadosItem: IItemOrcamento}>,
    limpar: ActionType<void>
} = atualizacaoItensOrcamentoLegadoSlice.actions